import { render, staticRenderFns } from "./CompetitionProductForm.vue?vue&type=template&id=047999f6&scoped=true"
import script from "./CompetitionProductForm.vue?vue&type=script&lang=js"
export * from "./CompetitionProductForm.vue?vue&type=script&lang=js"
import style0 from "./CompetitionProductForm.vue?vue&type=style&index=0&id=047999f6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047999f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('047999f6')) {
      api.createRecord('047999f6', component.options)
    } else {
      api.reload('047999f6', component.options)
    }
    module.hot.accept("./CompetitionProductForm.vue?vue&type=template&id=047999f6&scoped=true", function () {
      api.rerender('047999f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/priceSetting/priceMonitoring/competitionProductConfig/CompetitionProductForm.vue"
export default component.exports